import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { HttpClient } from '@angular/common/http';
import { PageDTO } from '../model/page-dto';

import { Router } from '@angular/router';
import { BackupScheduleDTO } from '../model/backup-schedule-dto';
import { BackupStorageDeviceDTO } from '../model/backup-storage-device-dto';

@Injectable({
    providedIn: 'root'
})
export class BackupService extends BaseService {

    constructor(http: HttpClient, router: Router) {
        super(http, router)
    }

    public getBackupSchedules(): Promise<PageDTO<BackupScheduleDTO>> {
        const request = this.get<PageDTO<BackupScheduleDTO>>(`backups/schedules?=pageNumber=1&pageSize=9999`);
        return this.apiCall<PageDTO<BackupScheduleDTO>>(request);
    }

    public getBackupDevices(): Promise<PageDTO<BackupStorageDeviceDTO>> {
        const request = this.get<PageDTO<BackupStorageDeviceDTO>>(`backups/devices?=pageNumber=1&pageSize=9999`);
        return this.apiCall<PageDTO<BackupStorageDeviceDTO>>(request);
    }

    public createBackupSchedule(schedule: BackupScheduleDTO): Promise<void> {
        const request = this.post<void>(`backups/schedules`, schedule);
        return this.apiCall<void>(request);
    }

    public updateBackupSchedule(schedule: BackupScheduleDTO): Promise<void> {
        const request = this.put<void>(`backups/schedules`, schedule);
        return this.apiCall<void>(request);
    }

    public deleteBackupSchedule(id: number): Promise<void> {
        const request = this.delete<void>(`backups/schedules/${id}`);
        return this.apiCall<void>(request);
    }

    public stopBackupSchedule(id: number): Promise<void> {
        const request = this.post<void>(`backups/schedules/${id}/disable`);
        return this.apiCall<void>(request);
    }

    public startBackupSchedule(id: number): Promise<void> {
        const request = this.post<void>(`backups/schedules/${id}/enable`);
        return this.apiCall<void>(request);
    }

    public runBackupSchedule(id: number): Promise<void> {
        const request = this.post<void>(`backups/schedules/${id}/run`);
        return this.apiCall<void>(request);
    }

    public createBackupDevice(device: BackupStorageDeviceDTO): Promise<void> {
        const request = this.post<void>(`backups/devices`, device);
        return this.apiCall<void>(request);
    }

    public updateBackupDevice(device: BackupStorageDeviceDTO): Promise<void> {
        const request = this.put<void>(`backups/devices`, device);
        return this.apiCall<void>(request);
    }

    public deleteBackupDevice(id: number): Promise<void> {
        const request = this.delete<void>(`backups/devices/${id}`);
        return this.apiCall<void>(request);
    }
}
